type LrTrackValues = boolean | number | string

interface LrEventProperties {
	[key: string]: LrTrackValues | LrTrackValues[]
}

export const createLrEvent = (args: { identifier: string; props: LrEventProperties }) => {
	const { identifier, props } = args

	if (import.meta.env.VITE_LOGROCKET_ID)
		try {
			window.LogRocket?.track(identifier, props)
		} catch (err) {
			console.error('LogRocket event failed: ', err)
		}
}

export type LrIdentifyPropertiesRegType = 'memberId' | 'ssn' | 'mbi'

interface LrIdentifyProperties {
	name?: string
	email?: string
	contractType?: string
	groupId?: string
	lob?: string
	memberId?: string
	planType?: string
	userName?: string
	registrationType?: LrIdentifyPropertiesRegType
	[key: string]: string | number | boolean | undefined
}

export const lrIdentify = (args: { uid: string; props: LrIdentifyProperties }) => {
	const { uid, props } = args

	if (import.meta.env.VITE_LOGROCKET_ID)
		try {
			const cleaned = Object.fromEntries(
				Object.entries(props).filter((entry): entry is [string, string] => entry[1] !== undefined)
			)

			window.LogRocket?.identify(uid, cleaned)
		} catch (err) {
			console.error('LogRocket identity failed: ', err)
		}
}
